import Head from 'next/head'

export function BodyBackgroundWhite() {
    return (
        <Head>
            <style
                key="white-background"
                type="text/css"
                dangerouslySetInnerHTML={{
                    __html: ':root { --body-background: #fff; }',
                }}
            />
        </Head>
    )
}
